import { Component, OnInit, Inject } from '@angular/core';
import { SharedService } from 'src/app/shared/service/shared.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { EnvironmentService } from 'src/app/core/services/environment.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { CausalResultantPopupComponent } from '../causal-resultant-popup/causal-resultant-popup.component';
import { DataService } from 'src/app/shared/service/data.service';
@Component({
  selector: 'app-time-loss-popup',
  templateUrl: './time-loss-popup.component.html',
  styleUrls: ['./time-loss-popup.component.scss']
})
export class TimeLossPopupComponent implements OnInit {


  displayedColumns: string[] = ['autoLoss', 'count', 'value'];
  dataSource: any[] = [];

  topLosses: any;
  localStorageData: any;
  dfosURL: any = 'https://dfos-ppd.unilever.com/#!/';
  bottleNeckData: any = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    private service: SharedService,
    private dialog: MatDialogRef<TimeLossPopupComponent>,
    private env: EnvironmentService,
    private matDialog: MatDialog,
    private dataSer: DataService
  ) {
    this.topLosses = data.popupData;
    this.localStorageData = JSON.parse(sessionStorage.getItem('caivanoDashboard'));
    this.dfosURL = this.env.getdfosRedirectURL();
    this.sortData();

    if (this.localStorageData) {
      if (this.localStorageData.cluster && this.localStorageData.cluster.clusterId) {
        this.dfosURL = this.dfosURL + 'clusters/' + this.localStorageData.cluster.clusterId;

        if (this.localStorageData.factory && this.localStorageData.factory.factoryId) {
          this.dfosURL = this.dfosURL + '/factories/' + this.localStorageData.factory.factoryId;

          if (this.localStorageData.line && this.localStorageData.line.lineId) {
            this.dfosURL = this.dfosURL + '/lines/' + this.localStorageData.line.lineId + '/lineDashboard';
          }
        }
      }
    }
  }

  ngOnInit() {
    this.dataSer.on('timeIntervalRefresh', this.timeIntervalDataChange);
  }

  dialogClose() {
    this.dialog.close();
  }

  openCausalPopup() {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.width = '550px';
    // dialogConfig.height = '550px';
    dialogConfig.autoFocus = false;
    dialogConfig.panelClass = 'causal-data-popup';
    dialogConfig.data = this.data;

    const dialogRef = this.matDialog.open(CausalResultantPopupComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(data => { });
  }

  sortData() {
    if (this.data.shiftOrThirty === 'Shift' && this.topLosses && this.topLosses.bottleNeckMachineData) {
      this.topLosses.bottleNeckMachineData.shift = this.topLosses.bottleNeckMachineData.shift.sort((a, b) => {
        return b.value - a.value;
      });
      this.bottleNeckData = this.topLosses.bottleNeckMachineData.shift.filter(shiftData => shiftData.machine === this.topLosses.name);
    } else if (this.data.shiftOrThirty === '30 Minutes' && this.topLosses && this.topLosses.bottleNeckMachineData) {
      this.topLosses.bottleNeckMachineData.thirtyMin = this.topLosses.bottleNeckMachineData.thirtyMin.sort((a, b) => {
        return b.value - a.value;
      });
      this.bottleNeckData = this.topLosses.bottleNeckMachineData.thirtyMin.filter(thirtyMinData =>
        thirtyMinData.machine === this.topLosses.name);
    }
    this.bottleNeckData.forEach(singleData => {
      if (singleData.autoLoss === '') {
        singleData.autoLoss = singleData.manualLoss;
      }
    });
    this.dataSource = this.bottleNeckData.filter((data, idx) => idx < 5);

  }

  timeIntervalDataChange = (newData: any) => {
    newData.forEach(currentData => {
      if (this.data && this.data.popupData && this.data.popupData.name && currentData.name &&
        this.data.popupData.name === currentData.name) {
        this.data.popupData = currentData;
        this.topLosses = currentData;
        this.sortData();
      }
    });
  }
}
